import {Action} from '@ngrx/store';

export const GET_FREELANCER_MESSAGES = '[Messages] Get Freelancer Messages';
export const GET_FREELANCER_MESSAGES_SUCCESS = '[Messages] Get Freelancer Messages Success';
export const GET_FREELANCER_MESSAGES_ERROR = '[Messages] Get Freelancer Messages Error';


export class GetFreelancerMessages implements Action {
  readonly type = GET_FREELANCER_MESSAGES;

  constructor(public payload: any) {
  }
}

export class GetFreelancerMessagesSuccess implements Action {
  readonly type = GET_FREELANCER_MESSAGES_SUCCESS;

  constructor(public payload: any) {
  }
}


export class GetFreelancerMessagesError implements Action {
  readonly type = GET_FREELANCER_MESSAGES_ERROR;

  constructor(public payload: any) {
  }
}


export type MessagesAction =
  GetFreelancerMessages
  | GetFreelancerMessagesSuccess
  | GetFreelancerMessagesError;



// WEBPACK FOOTER //
// /Users/Chetan/Downloads/angular5_admin-master/src/app/freelancers/store/actions/messages.action.ts